export const MANAGER_ORDERS_FR_FR = {
	orderDetailModal: {
		title: "Détails de la commande",
		orderNumber: "Commande n° #{{orderNumber}}",
		nameLabel: "Nom",
		dateLabel: "Date et heure",
		dateValue: "{{date}} à {{hour}}",
		originLabel: "Origine de la commande",
		refuseOrder: "Refuser la commande",
		acceptOrder: "Accepter la commande",
		cancelOrder: "Annuler la commande",
		readyOrder: "Commande prête",
		dispatchOrder: "Expédier la commande",
		concludeOrder: "Clôturer la commande",
		itemsTitle: "Articles de la commande",
		totalLabel: "Total",
		deliveryFeeLabel: "Frais de livraison",
		serviceFeeLabel: "Frais de service",
		additionalFeeLabel: "Frais de commande minimale",
		tipLabel: "Pourboire",
		tipReceiver: {
			MERCHANT: "Pourboire du magasin",
			LOGISTIC_SERVICES: "Pourboire du livreur",
			MARKETPLACE: "Pourboire de la marketplace",
		},
		discountLabel: "Remise",
		discountStoreLabel: "Remise du magasin",
		discountMarketplaceLabel: "Remise iFood",
		discountKeetaLabel: "Remise Keeta",
		discountFood99Label: "Remise 99Food",
		obsLabel: "Remarque",
		obsTitle: "Remarques complémentaires",
		deliveryDetailsTitle: "Détails de livraison",
		paymentMethodLabel: "Mode de paiement",
		paymentMethodCardValue: "Carte",
		changeBackLabel: "Monnaie à rendre",
		deliveryTypeLabel: "Type de livraison",
		deliveryByStoreValue: "Livraison par le magasin",
		deliveryByPlatformValue: "Livraison par la plateforme",
		locatorLabel: "Localisateur",
		needCutleryLabel: "Couverts",
		needCutleryYes: "Le client a demandé des couverts",
		addressLabel: "Adresse",
		contactLabel: "Contact",
		cpfLabel: "CPF",
		phoneLabel: "Téléphone",
		unknownLabel: "Document inconnu",
		unknown: "Non renseigné",
		printOrder: "Imprimer la commande",
		toastAcceptTitle: "Commande acceptée",
		toastAcceptDescription:
			'La commande <bold>#{{orderNumber}}</bold> a été acceptée et se trouve dans l\'onglet "<bold>Acceptées</bold>"',
		toastReadyTitle: "Commande prête",
		toastReadyDescription:
			'La commande <bold>#{{orderNumber}}</bold> est prête et se trouve dans l\'onglet "<bold>Prêtes</bold>"',
		toastDispatchTitle: "Commande expédiée",
		toastDispatchDescription:
			'La commande <bold>#{{orderNumber}}</bold> a été expédiée et se trouve dans l\'onglet "<bold>En livraison</bold>"',
		toastConcludeTitle: "Commande terminée",
		toastConcludeDescription:
			'La commande <bold>#{{orderNumber}}</bold> a été terminée et se trouve dans l\'onglet "<bold>Terminées</bold>"',
		toastCancelTitle: "Commande annulée",
		toastCancelDescription:
			'La commande <bold>#{{orderNumber}}</bold> a été annulée et se trouve dans l\'onglet "<bold>Annulées</bold>"',
		statusMessagePlaced: "Acceptez ou refusez la commande pour continuer.",
		statusMessageConfirmed:
			"Préparez la commande et marquez-la comme prête une fois terminée.",
		statusMessageReady: "Expédiez lorsque le livreur vient récupérer la commande.",
		statusMessageReadyDineIn:
			"Finalisez la commande lorsque le client la récupère sur place.",
		statusMessageDispatched: "Finalisez la commande une fois la livraison terminée.",
		statusCancelledTitle: "Commande annulée",
	},
	refuseOrderConfirmation: {
		title: "Voulez-vous annuler la commande ?",
		message:
			"Indiquez le motif de l'annulation ; après confirmation, le client sera informé via la plateforme intégrée.",
		confirmButton: "Confirmer l'annulation",
		secondaryMessage: "Cette action est irréversible.",
		reasonLabel: "Motif de l'annulation",
		reasonPlaceholder: "Sélectionnez ici le motif de l'annulation",
		reasonTextLabel: "Décrivez le motif (minimum 3 caractères)",
		reasonTextPlaceholder: "Décrivez le motif de l'annulation",
		reasons: {
			itemUnavailable: "Article indisponible",
			storeClosed: "Magasin fermé",
			storeOverloaded: "Magasin surchargé",
			infrastructureOutage: "Coupure d'électricité / problème technique",
			customerIssue: "Problème avec le client",
			outdatedMenu: "Menu obsolète",
			fraudSuspected: "Fraude suspectée",
			feesOrPromoDoubt: "Doute sur tarif ou promotion",
			noCourier: "Aucun livreur disponible",
			orderOutOfArea: "Commande hors zone de livraison",
			unsafeArea: "Adresse en zone à risque",
			other: "Autre motif",
		},
	},
};
